import React, { useEffect, useState } from 'react';
import { Button, Modal, Table } from 'react-bootstrap';
import * as Common from './Common';
import "../mcss/main.css";


const FaView = (props) => {

    const sid = sessionStorage.getItem('sessionId');
    const [faViewData, setFaViewData] = useState([]);
    const [show, setShow] = useState(false);
    const [narration, setNarration] = useState("");

    useEffect(() => {
        if (props.show) {
            Common.callApi(Common.apiFaViewLog, [sid, "getlog", JSON.stringify(props.faViewObject)], result => {
                let resp = JSON.parse(result);
                console.log(resp);
                setFaViewData(resp.faview);
                setNarration(resp.narration);
            });
        }
    }, [props.show]);

    return (
        <div>
            <Modal {...props} size='xl' centered dialogClassName="custom-modal-width">
                <Modal.Header closeButton>
                    <Modal.Title>FA View</Modal.Title>
                </Modal.Header>
                <Table responsive striped bordered>
                    <thead>
                        <tr>
                            <th>Location</th>
                            <th>Tran No</th>
                            <th>Account Name</th>
                            <th>Cr/Dr</th>
                            <th>Knock Off</th>
                            <th className="text-end" >Amount</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            faViewData.filter(item => item.tfd_reftype !== "GB").map((item, index) => (
                                <tr key={index}>
                                    <td>{item.location}</td>
                                    <td>{item.tranno}</td>
                                    <td>{item.data}</td>
                                    <td>{item.tfd_flag == "C" ? "Cr" : "Dr"}</td>
                                    <td>{item.tfd_knockoff_srno != 0 && (item.tranno?.trim() != (item.tfd_knockoff_type + ' ' + item.tfd_knockoff_srno)) ? (item.tfd_knockoff_type + ' ' + item.tfd_knockoff_srno):''}</td>
                                    <td className="text-end" >{Common.formatNumberDisplay(item.tfd_flag == "C" ? -1 * item.tfd_amount : item.tfd_amount)}&nbsp;</td>
                                    {/* <td>{item.tfd_amount > 0 ? item.tfd_amount : -1 * item.tfd_amount}</td> */}
                                </tr>
                            ))
                        }
                    </tbody>
                    <br></br>
                    <tbody>
                        {
                            faViewData.filter(item => item.tfd_reftype === "GB").map((item, index) => (
                                <tr key={index}>
                                    <td>{item.location}</td>
                                    <td>{item.tranno}</td>
                                    <td>{item.data}</td>
                                    <td>{item.tfd_flag == "C" ? "Cr" : "Dr"}</td>
                                    <td>{item.tfd_knockoff_srno != 0 && (item.tranno?.trim() != (item.tfd_knockoff_type + ' ' + item.tfd_knockoff_srno)) ? (item.tfd_knockoff_type + ' ' + item.tfd_knockoff_srno):''}</td>
                                    <td className="text-end" >{Common.formatNumberDisplay(item.tfd_flag == "C" ? -1 * item.tfd_amount : item.tfd_amount)}&nbsp;</td>
                                </tr>
                            ))
                        }
                    </tbody>
                </Table>
                {/* <p><b>Narration : </b> {narration}</p> */}
                <Modal.Body>
                    <p><b>Narration : </b> {narration}</p>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="primary" onClick={props.onHide}>
                        OK
                    </Button>
                </Modal.Footer>
            </Modal>
        </div>
    )
}

export default FaView
